import { render } from "./TrainingStartMenu.vue?vue&type=template&id=e6c4cd96&scoped=true"
import script from "./TrainingStartMenu.vue?vue&type=script&lang=js"
export * from "./TrainingStartMenu.vue?vue&type=script&lang=js"

import "./TrainingStartMenu.vue?vue&type=style&index=0&id=e6c4cd96&lang=scss&scoped=true"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6c4cd96"]])

export default __exports__